import { render, staticRenderFns } from "./TableContent.vue?vue&type=template&id=8bce860a"
import script from "./TableContent.vue?vue&type=script&lang=js"
export * from "./TableContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports